import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from 'ng2-translate';

import { RouteOverviewComponent } from './route-overview.component';

import { RouteOverviewService } from './services/route-overview.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    TranslateModule
  ],
  exports: [RouteOverviewComponent],
  declarations: [RouteOverviewComponent],
  providers: [RouteOverviewService]
})
export class RouteOverviewModule { }



// WEBPACK FOOTER //
// ./src/app/modules/route-overview/route-overview.module.ts